import Vue from "vue";
import { Products } from "@/ProductPage/ProductPageStateSchema";
import ProductPicker, { StrengthInformationModal } from "./";
import { loadJSON } from "../../../Utils/Util";

export function bindProductPicker(products: Products) {
  const mountingElement = document.getElementById("pp-mobile-friendly");

  if (!mountingElement) {
    return;
  }

  const strengthInfo: StrengthInformationModal | undefined = loadJSON("strength-info");

  new Vue({
    el: mountingElement,
    render: function (createElement) {
      return createElement(ProductPicker, {
        props: {
          data: products,
          strengthModal: strengthInfo,
        },
      });
    },
  });
}
